import Speedtest from './Speedtest';

const VIDEOS = [...document.querySelectorAll('.video-speedtest')];
let isPortrait = isInPortraitView();
let speedtestResult = 0;

Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
    get: function() {
        return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
    }
});

if (VIDEOS.length) {
    // Init Speedtest: return result and status
    // Result Matrix:
    // 1.5 == Fast 3G
    // 0.4 == Slow 3G
    new Speedtest(1, result => {
        console.log('video speed test', result);
        speedtestResult = result;
        VIDEOS.forEach(video => {
            insertVideo(video);

            let timeout;
            window.addEventListener('resize', () => {
                if (timeout) {
                    window.cancelAnimationFrame(timeout);
                }

                timeout = window.requestAnimationFrame(() => {
                    if (isPortrait != isInPortraitView() && !sizeCheck()) {
                        // Invert variable
                        isPortrait = !isPortrait;
                        insertVideo(video);
                    }
                });
            });
        });
    });
}

function sizeCheck() {
    return window.innerHeight < 600;
}

function insertVideo(video) {
    const data = video.dataset;
    if (speedtestResult < 0.4) {
        // Under 0.4 we do nothing, as the connection is to slow
    } else if (isPortrait && data.portrait) {
        insertPortraitVideo(video, data);
    } else {
        insertLandscapeVideo(video, data);
    }
}

function insertPortraitVideo(video, data) {
    insertSources(video, data.portrait);
}

function insertLandscapeVideo(video, data) {
    if (speedtestResult <= 1) {
        insertSources(video, data['360p'] || data['360p'] || data['360p'] || data.hd);
    } else if (speedtestResult <= 1.5) {
        insertSources(video, data['360p'] || data['360p'] || data.hd);
    } else if (speedtestResult <= 2.5) {
        insertSources(video, data['360p'] || data.hd);
    } else {
        insertSources(video, data.hd);
    }
}

function isInPortraitView() {
    return window.innerHeight / window.innerWidth > 1.5;
}

function insertSources(video, data) {
    if (video.playing) {
        video.pause();
    }
    setTimeout(() => {
        video.innerHTML = JSON.parse(data).reduce(
            (acc, source) => `${acc}<source src="${source.src}" type="video/${source.ext}" />`,
            ''
        );
    }, 0);
    setTimeout(() => {
        video.load();
        video.play();
    }, 10);
}
